import React, { Component } from 'react'
import moment from 'moment'
import {SingleDatePicker} from 'react-dates'
import { QueryService } from 'services/queries'
import ErrorType from 'services/ErrorType'
import config from 'services/config'
import MoneyValue from 'components/MoneyValue'

import 'react-dates/lib/css/_datepicker.css'

import jQuery from 'services/jQueryDatatablesBootstrap'


class BalanceAccountsTable extends Component {


  constructor(props) {
    super(props)
    this.state = {
      datatable: false,
      balanceSorting: 'desc'
    }
    this.balanceClicked = this.balanceClicked.bind(this);
  }

  
  componentDidUpdate() {

//    const columns = [
//      {
//        title: 'Account',
//        width: 120,
//        data: 'account'
//      },
//      {
//        title: 'Balance',
//        width: 180,
//        data: 'balance'
//      },
//    ]

    if (!this.state.datatable) {

      jQuery(this.refs.main).DataTable({
        ordering: true,
        order: [2, 'desc'],
        pageLength: 100,
        columns: [
          {orderable: true},
          {orderable: true},
          {orderable: false, visible: false}
        ]
      })

      this.setState({datatable: true})

    }


  }

  componentWillUnmount(){
    
    jQuery('#accts').DataTable().destroy(true)

  }

  async balanceClicked(e) {
    
    e.preventDefault()

    await this.setState( prevState => ({
      balanceSorting:
        prevState.balanceSorting
        ? (prevState.balanceSorting === 'asc') ? 'desc' : 'asc'
        : 'desc'
    }))

    jQuery('#accts').DataTable()
      .order( [ 2, this.state.balanceSorting ] )
      .draw()

    jQuery('#balance-header').removeClass('sorting_disabled sorting sorting_asc sorting_desc')
    jQuery('#balance-header').addClass('sorting_' + this.state.balanceSorting)

  }

  balanceUnClicked(e) {
    jQuery('#balance-header').addClass('sorting')
  }

  render() {

    let balanceSortStatus = this.state.datatable ? jQuery('#accts').DataTable().order() : null
    let postFix = (balanceSortStatus && (balanceSortStatus[0] === 3)) ? '_' + balanceSortStatus[1] : ''
    console.log(postFix)

    return (
      <div className="card">
        <div className="card-body">
          <table className="table table-hover table-bordered" ref="main" id="accts">
            <thead>
              <tr>
                <th className="col-md-4" onClick={this.balanceUnClicked}>Account</th>
                <th id="balance-header" className={'col-md-4 text-right ' + 'sorting' + postFix} onClick={this.balanceClicked}>Balance</th>
                <th className="hidden">...</th>
              </tr>
            </thead>
            <tbody>
              {this.props.data.map( row =>
                <tr>
                  <td>{row.account}</td>
                  <td className="text-right"><MoneyValue value={row.balance}/></td>
                  <td>{row.balance}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}


class AccountBalances extends Component {

  constructor(props) {

    super(props)
    this.state = {
      balanceDate: moment('2017-06-30'),
      balanceDateFocus: false,
      balances: [],
      currentPage: 1,
      pageSize: 100,
      recordCount: 0
    }

    this.onBalanceDateChange = this.onBalanceDateChange.bind(this)
    this.onBalanceDateFocusChange = this.onBalanceDateFocusChange.bind(this)
    this.isOutsideBalanceDateRange = this.isOutsideBalanceDateRange.bind(this)
    this.onPaginationChanged = this.onPaginationChanged.bind(this)
    this.downloadCsv = this.downloadCsv.bind(this)
    this.queryService = new QueryService(this.props.book)

  }

  async componentWillMount() {
    let newBalances = await this._fetchBalances(this.state.balanceDate)
    this.setState({...newBalances})
  }


  onBalanceDateFocusChange(p) {
    this.setState({
      balanceDateFocus: p.focused
    })
  }

  async downloadCsv() {
    this.queryService.downloadSellerBalances(this.state.balanceDate)
  }

  async onBalanceDateChange(date) {
    let newBalances = await this._fetchBalances(date)
    this.setState({...newBalances})
  }

  async _fetchBalances(date) {
    try {
      let result = await this.queryService.getBalanceAccounts('seller_receivables', date)
      console.log(result)
      return {
        balances: result,
        balanceDate: date
      }
    } catch (err) {
      if (err && err.type) {
        if (err.type === ErrorType.Authorization) {
          this.props.history.push(config.loginPage)
          return
        }
      }
      throw err
    }
  }

  isOutsideBalanceDateRange(date) {
    return moment('2017-07-01').isBefore(date)
  }

  onPaginationChanged(pagination) {

  }

  render() {
    return (
      <div className="content-wrapper">
        <div className="page-title">
          <div>
            <h1><i className="fa fa-th-list"></i> Balance details</h1>
            <p>Balances by account</p>
          </div>
          <div className="form-inline">
{/*            <label className="header-input">
              <span className="period">Journal</span>
              <select className="form-control">
                <option value="cash">Cash</option>
                <option value="buyer_receivables">Buyer receivables</option>
                <option value="seller_receivables">Seller receivables</option>
                <option value="expenses">Expenses</option>
                <option value="seller_payables">Seller payables</option>
                <option value="revenues">Revenues</option>
              </select>
            </label> */}
            <label className="header-input">
              <span className="period">Date</span>
              <SingleDatePicker
                date={this.state.balanceDate}
                onDateChange={this.onBalanceDateChange}
                onFocusChange={this.onBalanceDateFocusChange}
                focused={this.state.balanceDateFocus}
                numberOfMonths={1}
                isOutsideRange={this.isOutsideBalanceDateRange} />
            </label>

            {/*<ul className="breadcrumb">
              <li><i className="fa fa-home fa-lg"></i></li>
              <li>Tables</li>
              <li className="active"><a href="#">Simple Tables</a></li>
            </ul>*/}
          </div>
        </div>
        <div className="row">
          <div className="col-md-10 col-md-offset-1">
            <BalanceAccountsTable data={this.state.balances} />
          </div>
        </div>
      </div>
    )
  }
}

export default AccountBalances




// WEBPACK FOOTER //
// ./src/containers/Dashboard/AccountBalances/index.js